import { randomIndexInArray } from './helpers';

const state = {
	animating: false,
	attempts: 0
};

const $padlock = $('.error-padlock .padlock');
const $shackle = $('.error-padlock .padlock-shackle');
const $keyhole = $('.error-padlock .padlock-keyhole');
const $msg = $('.error-message-text');

const failureMessages = [
	'What do you think you\'re doing, Agent?',
	'Stop that, Agent.',
	'This area is confidential.',
	'This area is restricted.',
	'You are not authorized to access this area.',
	'Control shall hear about this.',
	'You do not have clearance.'
];

function animate($elem, classname, keepState = false) {
	return new Promise((resolve, reject) => {
		$elem.addClass(classname);
		$elem.one('animationend', function (e) {
			e.stopPropagation();
			if (!keepState) $elem.removeClass(classname);
			resolve();
		});
	});
}

function typeMessage(msg, speed = 75) {
	return new Promise((resolve, reject) => {
		let i = 0;
		let txt = '';

		function appendCharacter() {
			txt += msg.charAt(i);
			$msg.text(txt);
			i++;

			while (msg.charAt(i) === ' ') {
				appendCharacter();
			}
		}

		(function typeWriter() {
			if (i < msg.length) {
				appendCharacter();

				setTimeout(typeWriter, speed);
			} else {
				resolve();
			}
		})();
	});
}

function getFailMessage() {
	const i = randomIndexInArray(failureMessages);
	return failureMessages.splice(i, 1)[0];
}

async function tryOpen() {
	if (state.attempts >= 3) {
		await openSuccess();
	} else {
		await openFail();
	}
}

async function openFail() {
	if (!state.animating) {
		state.animating = true;
		state.attempts++;
		await animate($shackle, 'open-fail');
		await animate($padlock, 'shake');

		const message = getFailMessage();

		await typeMessage(message);
		state.animating = false;
	}
}

async function openSuccess() {
	if (!state.animating) {
		state.animating = true;
		state.attempts++;
		await animate($shackle, 'open-success', true);
		await animate($padlock, 'fade-out', true);

		$padlock.css({ 'pointer-events': 'none' });

		await typeMessage('Congratulations, Agent. Your persistence paid off. Unfortunately there was nothing behind the lock.');
		state.animating = false;
	}
}

$keyhole.on('click', function (e) {
	e.preventDefault();
	tryOpen().catch(console.log);
});
